export const getRequest = async (path, controller) => {
  try {
    const response = await fetch(path, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      signal: controller.signal,
      credentials: 'include'
    })

    if (response.ok) {
      return await response.json()
    }
  } catch (error) {
    console.log(error)
  }

  return false
}

export const postRequest = async (path, body) => {
  try {
    /*const test = await fetch('/api/user/session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    // console.log(await test.text())*/

    const response = await fetch(path, {
      method: 'POST',
      headers: {
        // 'X-CSRF-Token': await test.text(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      credentials: 'include'
    })

    if (response.ok) {
      return await response.json()
    }
  } catch (error) {
    console.log(error)
  }

  return false
}

export const patchRequest = async (path, body) => {
  try {
    const response = await fetch(path, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      credentials: 'include'
    })

    if (response.ok) {
      return await response.json()
    }
  } catch (error) {
    console.log(error)
  }

  return false
}

export const deleteRequest = async (path) => {
  try {
    const response = await fetch(path, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    })

    if (response.ok) {
      return await response.json()
    }
  } catch (error) {
    console.log(error)
  }

  return false
}
